// Contagem e resultado por lugar (§14.3).
import * as z from 'zod/mini';
import {
  type CandidateNumber,
  CandidateNumberSchema,
  IntSchema,
  type Iso,
  IsoSchema,
  type PlaceCode,
  PlaceCodeSchema,
} from './base';

export interface Tally {
  /** Seções do lugar (> 0). */
  sections: number;
  sections_counted: number;
  /** Eleitores aptos. */
  electorate: number;
  /** Aptos das seções totalizadas. */
  electorate_counted: number;
  /** Comparecimento nas seções totalizadas. */
  turnout: number;
  blank_votes: number;
  null_votes: number;
  /** = Σ votes (I-07). */
  valid_votes: number;
  /** Só os 2 candidatos da disputa. */
  votes: Record<CandidateNumber, number>;
  /** Candidatura anulada sub judice; fora dos válidos. */
  annulled_votes?: Record<CandidateNumber, number>;
}
export type CountStatus = 'no_data' | 'counting' | 'complete';
export interface Decision {
  kind: 'math' | 'tse';
  winner: CandidateNumber;
  /** tse_ht do 1º snapshot que satisfez a regra. */
  at: Iso;
  /** seq desse snapshot. */
  seq: number;
}
export interface PlaceResult extends Tally {
  place: PlaceCode | 'BR';
  /** Hora do arquivo do TSE deste lugar. */
  tse_ht: Iso | null;
  status: CountStatus;
  math_decision: Decision | null;
  tse_result: Decision | null;
}

export const CountStatusSchema = z.enum(['no_data', 'counting', 'complete']);

export const tallyShape = {
  sections: IntSchema,
  sections_counted: IntSchema,
  electorate: IntSchema,
  electorate_counted: IntSchema,
  turnout: IntSchema,
  blank_votes: IntSchema,
  null_votes: IntSchema,
  valid_votes: IntSchema,
  votes: z.record(CandidateNumberSchema, IntSchema),
  annulled_votes: z.optional(z.record(CandidateNumberSchema, IntSchema)),
};
export const TallySchema = z.object(tallyShape);

export const DecisionSchema = z.object({
  kind: z.enum(['math', 'tse']),
  winner: CandidateNumberSchema,
  at: IsoSchema,
  seq: IntSchema,
});

export const placeResultShape = {
  ...tallyShape,
  place: z.union([PlaceCodeSchema, z.literal('BR')]),
  tse_ht: z.nullable(IsoSchema),
  status: CountStatusSchema,
  math_decision: z.nullable(DecisionSchema),
  tse_result: z.nullable(DecisionSchema),
};
export const PlaceResultSchema = z.object(placeResultShape);
